module.exports = __webpack_public_path__ + "static/media/possible3.9abf6342.webp";